import styled from 'styled-components';
import {Colors} from "../../../../../../../components/theme";

// Define Col widths from one place
const tableColWidths = {
    index: '40px',
    name: '160px',
    telephone: '160px',
    email: '230px',
    project: '120px'
};

// Table colors
const rowColors = {
    odd: '#fff',
    evenRegular: '#eef6fb',
    evenRenfort: '#fff4e6',
    total: '#94e0ac',
    required: '#ffeaa5',
    instrumentLabel: '#a5d2ff'
};

// Define sticked left css rules
const stickedLeft = {
    position: 'sticky',
    zIndex: '2'
};

const TableCell = styled.td`
  transition: min-width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  width: ${(props) => (props.isHidden ? "80px" : "auto")};
  text-align: left;
  white-space: nowrap;
`;

//Fake right border after email
const StickyBorderRight = styled(TableCell)`
  position: sticky;
  z-index: 3;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: #ccc;
    z-index: 4;
  }
`;

// Styled components
const TableHeader = styled.th`
  transition: min-width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  cursor: pointer;
  text-align: left;
  width: ${(props) => (props.isHidden ? "80px !important" : "auto")};
  &:hover {
    opacity: 0.7;
  }
`;

const TxtTitlesTable = styled.p`
  font-size: 0.7em;
  text-transform: uppercase;
  width: 100%;
  padding: 5px 0 0 0;
  margin: 0;
  color: ${Colors.darkRed};
`;

const ToggleButton = styled.button`
  &.active {
    background-color: #0d6efd;
    color: white;
    border-color: #0d6efd;
  }
`;

export {
    tableColWidths,
    rowColors,
    stickedLeft,
    TableCell,
    StickyBorderRight,
    TableHeader,
    TxtTitlesTable,
    ToggleButton
}